import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../hooks/useTheme.js';
import { Heading } from '../Heading/Heading.js';
import { Box } from '../Box/index.js';

var DialogHeading = function (_a) {
    var sx = _a.sx, children = _a.children, props = __rest(_a, ["sx", "children"]);
    var mergeStyles = useTheme().mergeStyles;
    var baseStyle = mergeStyles([
        {
            px: "24px",
            py: "20px",
            pr: "54px",
            gridArea: "title",
        },
        sx,
    ]);
    return (jsx(Box, __assign({ sx: baseStyle }, props, { children: jsx(Heading, __assign({ level: "5", component: "h2" }, { children: children })) })));
};

export { DialogHeading };
//# sourceMappingURL=DialogHeading.js.map
